import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cancel: string;
    copyFolder: string;
    copyDetails: string;
    copyTitle: string;
    duplicateFolder: string;
    duplicateDetails: string;
    duplicateTitle: string;
    metadataWarningTitle: string;
    metadataWarningDescription: string;
    copyAnyway: string;
    duplicateAnyway: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            copyFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.copyFolder?c=2vnb5u7qv4zft", defaultMessage: "Copy" }));
                },
                enumerable: true,
                configurable: true
            },
            copyDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.copyDetails?c=1qozuxgmku01y", defaultMessage: "Folder members will not be added to the copy. Only you will have access." }));
                },
                enumerable: true,
                configurable: true
            },
            copyTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.copyTitle?c=kpv7y9emqxg0", defaultMessage: "You''re about to copy a restricted folder" }));
                },
                enumerable: true,
                configurable: true
            },
            duplicateFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.duplicateFolder?c=gwcnintdwpnx", defaultMessage: "Duplicate" }));
                },
                enumerable: true,
                configurable: true
            },
            duplicateDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.duplicateDetails?c=fz0kh3wq3nxm", defaultMessage: "Folder members will not be added to the duplicate. Only you will have access." }));
                },
                enumerable: true,
                configurable: true
            },
            duplicateTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.duplicateTitle?c=1in5meenih1wb", defaultMessage: "You''re about to duplicate a restricted folder" }));
                },
                enumerable: true,
                configurable: true
            },
            metadataWarningTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.metadataWarningTitle?c=1h98rhsvl2208", defaultMessage: "Custom fields will be lost" }));
                },
                enumerable: true,
                configurable: true
            },
            metadataWarningDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.metadataWarningDescription?c=23l8do7ztnlts", defaultMessage: "Any custom fields or field values will be lost on copied assets in a new project." }));
                },
                enumerable: true,
                configurable: true
            },
            copyAnyway: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.copyAnyway?c=1xpfadk3th46f", defaultMessage: "Copy Anyway" }));
                },
                enumerable: true,
                configurable: true
            },
            duplicateAnyway: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyAssets.duplicateAnyway?c=2fh0pg2rsu3vz", defaultMessage: "Duplicate Anyway" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
